import React from 'react';
import moment from 'moment';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import './InterruptionTable.css'
import { DATE_FORMAT } from "../../../constants/CommonConstants";

export const InterruptionTable = (props) => {
    let headerList = [];
    props.analysisDataList.forEach(data => {
        headerList.push(moment(data.date, DATE_FORMAT).format(props.intl.formatMessage({ id: "date_format2"})) + '(' + props.intl.formatMessage({ id: moment(data.date, DATE_FORMAT).format('ddd') }) + ')');
    });
    headerList.push(props.intl.formatMessage({ id: "Total" }));
    
    const classes = useRowStyles;
    const interruptionDataList = getDataList(props);
    const worseInterruptionList = getWorseData(props);

    return (
        <div className="interruption-table-wrapper">
        <div className="interruption-table-title" >{props.intl.formatMessage({ id: "top_operator_subtitle_interruption_result" })}</div>            
        <div className="zoom-button" style={{backgroundImage: `url(${props.zoomButtonIcon})`}} onClick={props.onFullScreenButtonClick} ></div>
            <div className="interruption-table-explanation"> 
            <span>{props.intl.formatMessage({ id: "top_operator_explanation_worst1" })}</span>
            <div className="explanation-square worst1"></div>
            <span>{props.intl.formatMessage({ id: "top_operator_explanation_worst2" })}</span>
            <div className="explanation-square worst2"></div>
            <span>{props.intl.formatMessage({ id: "top_operator_explanation_worst3" })}</span>
            <div className="explanation-square worst3"></div>
        </div>
        <TableContainer component={Paper} className="interruption-table-container">
            <Table stickyHeader className="interruption-table" aria-label="collapsible table">
                <TableHead>
                    <TableRow className={classes.header}>
                        <TableCell style={{ width: "5%"}}/>
                        <TableCell style={{ width: "15%"}}/>
                        {headerList.map((date,index) => (
                            <TableCell align="center" style={{ width: "10%"}}>{date}</TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {interruptionDataList.map((row, index, array) => (
                        <Row key={index} row={row} lastIndexFlag={array.length -1 === index} intl={props.intl} worseData={worseInterruptionList}/>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
        </div>
    );
}

const setHighlightedColumn = (columnName) => {
    var elements = document.getElementsByClassName(columnName);
    Array.from(elements).forEach((element) => {
    element.classList.add("hover");
    });
}

const removeHighlightedColumn = (columnName) => {
    var elements = document.getElementsByClassName(columnName);
    Array.from(elements).forEach((element) => {
    element.classList.remove("hover");
    });
}

const getWorseData = (props) => {
    let timeList = []
    props.analysisDataList.forEach(data => {
        data.jobInterruption.forEach(interruption => {
            timeList.push(interruption.paperEmpty);
            timeList.push(interruption.paperJams);
            timeList.push(interruption.trayFull);
            timeList.push(interruption.tonerEmpty);
            timeList.push(interruption.otherTransportError);
        });
    });
    if (timeList.length > 0) {
        timeList.sort(function(a, b) {return b - a});
        let worseList = timeList.slice(0, 3);
        return worseList.map(data => Math.round(data / 60));
    }
    return timeList;
}

const useRowStyles = {
    root: {
        '& > *': {
            borderBottom: 'unset',
            padding: '1px',
            fontSize: '16px',
            width: '100%',
            textAlign: 'left'
        },
        '&:hover':{
            backgroundColor: '#eaf1f8 !important',
        }
    },
    header: {
        '& > *': {
            padding: '1px',
            fontSize: '14px',
            maxWidth: '60px',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            color: '#77777B',
            backgroundColor: '#FFFFFF'
        },
    },
    total: {
        '& > *': {
            borderTop: 'unset',
            padding: '1px',
            fontSize: '16px',
        }
    },
    default: {
        width: '10%',
        maxWidth: '60px',
        textAlign: 'center',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        padding: '1px',
        height: '2rem'
    },
    worst1: {
        width: '10%',
        maxWidth: '60px',
        textAlign: 'center',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        padding: '1px',
        height: '2rem',
        backgroundColor: '#53a9ff',
    },
    worst2: {
        width: '10%',
        maxWidth: '60px',
        textAlign: 'center',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        padding: '1px',
        height: '2rem',
        backgroundColor: '#91c6fb',
    },
    worst3: {
        width: '10%',
        maxWidth: '60px',
        textAlign: 'center',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        padding: '1px',
        height: '2rem',
        backgroundColor: '#b9d8f7',
    },
    hover: {
        '&:hover': {
            backgroundColor: '#eaf1f8 !important',
        }
    },
    total_title: {
        fontWeight: "bold",
        backgroundColor: '#f2f9ff'
    },
    column_c: {
        fontWeight: "bold",
        backgroundColor: '#e5f2ff'
    }
};


const getBgColor = (data, props, factor, classes, totalFlag) => {
    // Totalの場合は色付けしない
    if ((!props.lastIndexFlag && data[factor.id] === "0") || totalFlag) {
        return classes.default;
    } else if (!props.lastIndexFlag && data[factor.id] === props.worseData[0].toLocaleString()) {
        return classes.worst1;
    } else if (!props.lastIndexFlag && data[factor.id] === props.worseData[1].toLocaleString()) {
        return classes.worst2;
    } else if (!props.lastIndexFlag && data[factor.id] === props.worseData[2].toLocaleString()) {
        return classes.worst3;
    } else {
        return classes.default;
    }
}

const getTotalBgColor = (data, props, factor, classes, totalFlag) => {
    if (totalFlag) {
        // Total例で最も長い値の場合は色付け
        let eachFactorDailyList = props.row.eachFactorDailyList[7];
        let paperEmpty = eachFactorDailyList.paperEmpty.split(",").join("");
        let paperJams = eachFactorDailyList.paperJams.split(",").join("");
        let tonerEmpty = eachFactorDailyList.tonerEmpty.split(",").join("");
        let trayFull = eachFactorDailyList.trayFull.split(",").join("");
        let otherTransportError = eachFactorDailyList.otherTransportError.split(",").join("");
        let maxval = Math.max(paperEmpty, paperJams, tonerEmpty, trayFull, otherTransportError);

        if (!props.lastIndexFlag && data[factor.id] === maxval.toLocaleString() && maxval !== 0) {
            return classes.worst1;
        } else {
            return classes.column_c;
        }
    }
}

const getTitleBgColor = (lastIndexFlag, classes) => {
    if (lastIndexFlag) {
        return classes.column_c;
    } else {
        return classes.total_title;
    }
}

function Row(props) {
    const { row, intl } = props;
    const [open, setOpen] = React.useState(true);
    const classes = useRowStyles;
    const factors = [
        {
            id : "paperEmpty",
            name : intl.formatMessage({ id: "top_operator_paperempty" })
        },
        {
            id : "trayFull",
            name : intl.formatMessage({ id: "top_operator_trayfull" })
        },
        {
            id : "paperJams",
            name : intl.formatMessage({ id: "top_operator_paperjams" })
        },
        {
            id : "tonerEmpty",
            name : intl.formatMessage({ id: "top_operator_tonerempty" })
        },
        {
            id: "otherTransportError",
            name: intl.formatMessage({ id: "top_operator_otherTransporterror" })
        },
    ];

    return (
        <React.Fragment>
        <TableRow hover className={props.lastIndexFlag ? classes.total : classes.root}>
            <TableCell style={{ width: "5%"}}>
                <IconButton style={{ border: "none", outline: "none"}} aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
                    {open ? <KeyboardArrowUpIcon style={{ fontSize: "1em"}} /> : <KeyboardArrowRightIcon style={{ fontSize: "1em"}} />}
                </IconButton>
            </TableCell>
            <TableCell component="th" scope="row" style={{ width: "15%", textAlign: 'left'}} className={"machine " + classes.default + " " + getTitleBgColor(props.lastIndexFlag, classes)} onMouseEnter={() => setHighlightedColumn("machine")}  onMouseLeave={()=> removeHighlightedColumn("machine")}>{row.machine}</TableCell>
            <TableCell align="center" className={"date1 " + classes.default + " " + getTitleBgColor(props.lastIndexFlag, classes)} onMouseEnter={() => setHighlightedColumn("date1")} onMouseLeave={() => removeHighlightedColumn("date1")}>{row.date1}</TableCell>
                <TableCell align="center" className={"date2 " + classes.default + " " + getTitleBgColor(props.lastIndexFlag, classes)} onMouseEnter={() => setHighlightedColumn("date2")} onMouseLeave={() => removeHighlightedColumn("date2")}>{row.date2}</TableCell>
                <TableCell align="center" className={"date3 " + classes.default + " " + getTitleBgColor(props.lastIndexFlag, classes)} onMouseEnter={() => setHighlightedColumn("date3")} onMouseLeave={() => removeHighlightedColumn("date3")}>{row.date3}</TableCell>
                <TableCell align="center" className={"date4 " + classes.default + " " + getTitleBgColor(props.lastIndexFlag, classes)} onMouseEnter={() => setHighlightedColumn("date4")} onMouseLeave={() => removeHighlightedColumn("date4")}>{row.date4}</TableCell>
                <TableCell align="center" className={"date5 " + classes.default + " " + getTitleBgColor(props.lastIndexFlag, classes)} onMouseEnter={() => setHighlightedColumn("date5")} onMouseLeave={() => removeHighlightedColumn("date5")}>{row.date5}</TableCell>
                <TableCell align="center" className={"date6 " + classes.default + " " + getTitleBgColor(props.lastIndexFlag, classes)} onMouseEnter={() => setHighlightedColumn("date6")} onMouseLeave={() => removeHighlightedColumn("date6")}>{row.date6}</TableCell>
                <TableCell align="center" className={"date7 " + classes.default + " " + getTitleBgColor(props.lastIndexFlag, classes)} onMouseEnter={() => setHighlightedColumn("date7")} onMouseLeave={() => removeHighlightedColumn("date7")}>{row.date7}</TableCell>
            <TableCell align="center" className={"totalColumn " + classes.default + " " + classes.column_c} onMouseEnter={() => setHighlightedColumn("totalColumn")}  onMouseLeave={()=> removeHighlightedColumn("totalColumn")}>{row.total}</TableCell>
        </TableRow>
        <TableRow>
            <TableCell style={{ padding: 0 }} colSpan={11}>
            <Collapse in={open} timeout="auto" unmountOnExit>
                <Table>
                    {factors.map((factor, index) => (
                        <TableRow hover key={index} className={props.lastIndexFlag ? classes.total : classes.root}>
                            <TableCell align="left" component="th" style={{ width: "20%", fontSize:"14px", paddingLeft:"5%"}}>{factor.name}</TableCell>
                            {row.eachFactorDailyList.map((data, index, array) => (
                                <TableCell align="center" style={{ fontSize:"16px"}}
                                className={getClassName(array,index) + " " +getBgColor(data, props, factor, classes, array.length - 1 === index) + " " + getTotalBgColor(data, props, factor, classes, array.length - 1 === index)} 
                                onMouseEnter={() => setHighlightedColumn(getClassName(array,index))}  onMouseLeave={()=> removeHighlightedColumn(getClassName(array,index))}
                                >{data[factor.id]}</TableCell>
                            ))}
                        </TableRow>
                    ))}
                </Table>
            </Collapse>
            </TableCell>
        </TableRow>
        </React.Fragment>
    );
}

function getClassName(array,index){
    return array.length - 1 === index ? "totalColumn" : "date"+ (index+1);
}

function getDataList(props) {
    let dataList = [];
    let totalInterruptionList = [];

    props.machineList.forEach(machine => {
        let interruptionTotalTimeDailyList = [];
        let eachFactorDailyList = [];
        let totalInterruption = {
            trayFull : 0,
            tonerEmpty : 0,
            paperEmpty : 0,
            paperJams : 0,
            otherTransportError: 0,
        };
        props.analysisDataList.forEach(analysisData => {
            let interruptionTimeDailyData = 0;
            let interruption = {
                trayFull : 0,
                tonerEmpty : 0,
                paperEmpty : 0,
                paperJams : 0,
                otherTransportError: 0,
            };
            analysisData.jobInterruption.forEach(interruptionData => {
                if (machine.serialNumber === interruptionData.serialNumber) {
                    interruption.trayFull = Math.round(interruptionData.trayFull / 60);
                    interruption.tonerEmpty = Math.round(interruptionData.tonerEmpty / 60);
                    interruption.paperEmpty = Math.round(interruptionData.paperEmpty / 60);
                    interruption.paperJams = Math.round(interruptionData.paperJams / 60);
                    interruption.otherTransportError = Math.round(interruptionData.otherTransportError / 60);
                    interruptionTimeDailyData = interruption.trayFull + interruption.tonerEmpty + interruption.paperEmpty + interruption.paperJams + interruption.otherTransportError;

                    totalInterruption.trayFull += Math.round(interruptionData.trayFull / 60);
                    totalInterruption.tonerEmpty += Math.round(interruptionData.tonerEmpty / 60);
                    totalInterruption.paperEmpty += Math.round(interruptionData.paperEmpty / 60);
                    totalInterruption.paperJams += Math.round(interruptionData.paperJams / 60);
                    totalInterruption.otherTransportError += Math.round(interruptionData.otherTransportError / 60);
                }
            });
            // カンマ区切り処理
            interruption.trayFull = interruption.trayFull.toLocaleString();
            interruption.tonerEmpty = interruption.tonerEmpty.toLocaleString();
            interruption.paperEmpty = interruption.paperEmpty.toLocaleString();
            interruption.paperJams = interruption.paperJams.toLocaleString();
            interruption.otherTransportError = interruption.otherTransportError.toLocaleString();
            eachFactorDailyList.push(interruption);
            
            interruptionTotalTimeDailyList.push(interruptionTimeDailyData);
            interruptionTimeDailyData = 0;
        });
        // カンマ区切り処理
        totalInterruption.trayFull = totalInterruption.trayFull.toLocaleString();
        totalInterruption.tonerEmpty = totalInterruption.tonerEmpty.toLocaleString();
        totalInterruption.paperEmpty = totalInterruption.paperEmpty.toLocaleString();
        totalInterruption.paperJams = totalInterruption.paperJams.toLocaleString();
        totalInterruption.otherTransportError = totalInterruption.otherTransportError.toLocaleString();
        eachFactorDailyList.push(totalInterruption);

        // ============================================================
        //       マシンごとの合計欄の設定
        // ============================================================
        dataList.push({
            machine : machine.name,
            date1: interruptionTotalTimeDailyList[0].toLocaleString(),
            date2: interruptionTotalTimeDailyList[1].toLocaleString(),
            date3: interruptionTotalTimeDailyList[2].toLocaleString(),
            date4: interruptionTotalTimeDailyList[3].toLocaleString(),
            date5: interruptionTotalTimeDailyList[4].toLocaleString(),
            date6: interruptionTotalTimeDailyList[5].toLocaleString(),
            date7: interruptionTotalTimeDailyList[6].toLocaleString(),
            total: interruptionTotalTimeDailyList.reduce((sum, element) => sum + element).toLocaleString(),
            eachFactorDailyList,
        });
        eachFactorDailyList = [];
        interruptionTotalTimeDailyList = [];
    });

    // ============================================================
    //       合計欄の計算
    // ============================================================
    if (props.analysisDataList.length > 0) {
        let totalweeklyAnalysisDataList = [];
        let totalInterruption = {
            trayFull : 0,
            tonerEmpty : 0,
            paperEmpty : 0,
            paperJams : 0,
            otherTransportError: 0,
        };
        props.analysisDataList.forEach(analysisData => {
            let interruption = {
                trayFull : 0,
                tonerEmpty : 0,
                paperEmpty : 0,
                paperJams : 0,
                otherTransportError: 0,
            };
            analysisData.jobInterruption.forEach(interruptionData => {
                interruption.trayFull += Math.round(interruptionData.trayFull / 60);
                interruption.tonerEmpty += Math.round(interruptionData.tonerEmpty / 60);
                interruption.paperEmpty += Math.round(interruptionData.paperEmpty / 60);
                interruption.paperJams += Math.round(interruptionData.paperJams / 60);
                interruption.otherTransportError += Math.round(interruptionData.otherTransportError / 60);

                totalInterruption.trayFull += Math.round(interruptionData.trayFull / 60);
                totalInterruption.tonerEmpty += Math.round(interruptionData.tonerEmpty / 60);
                totalInterruption.paperEmpty += Math.round(interruptionData.paperEmpty / 60);
                totalInterruption.paperJams += Math.round(interruptionData.paperJams / 60);
                totalInterruption.otherTransportError += Math.round(interruptionData.otherTransportError / 60);
            });
            totalweeklyAnalysisDataList.push(Object.values(interruption).reduce((sum, element) => sum + element));
            // カンマ区切り処理
            interruption.trayFull = interruption.trayFull.toLocaleString();
            interruption.tonerEmpty = interruption.tonerEmpty.toLocaleString();
            interruption.paperEmpty = interruption.paperEmpty.toLocaleString();
            interruption.paperJams = interruption.paperJams.toLocaleString();
            interruption.otherTransportError = interruption.otherTransportError.toLocaleString();
            totalInterruptionList.push(interruption);
        })
        // カンマ区切り処理
        totalInterruption.trayFull = totalInterruption.trayFull.toLocaleString();
        totalInterruption.tonerEmpty = totalInterruption.tonerEmpty.toLocaleString();
        totalInterruption.paperEmpty = totalInterruption.paperEmpty.toLocaleString();
        totalInterruption.paperJams = totalInterruption.paperJams.toLocaleString();
        totalInterruption.otherTransportError = totalInterruption.otherTransportError.toLocaleString();
        totalInterruptionList.push(totalInterruption);

        dataList.push({
            machine : props.intl.formatMessage({ id: "Total" }), 
            date1: Math.round(totalweeklyAnalysisDataList[0]).toLocaleString(),
            date2: Math.round(totalweeklyAnalysisDataList[1]).toLocaleString(),
            date3: Math.round(totalweeklyAnalysisDataList[2]).toLocaleString(),
            date4: Math.round(totalweeklyAnalysisDataList[3]).toLocaleString(),
            date5: Math.round(totalweeklyAnalysisDataList[4]).toLocaleString(),
            date6: Math.round(totalweeklyAnalysisDataList[5]).toLocaleString(),
            date7: Math.round(totalweeklyAnalysisDataList[6]).toLocaleString(),
            total: totalweeklyAnalysisDataList.reduce((sum, element) => sum + element).toLocaleString(),
            eachFactorDailyList: totalInterruptionList
        });
    }

    return dataList;
}
